<template>
  <div class="poi-picker">
    <popup ref="popup" full-screen :title="title" @confirm="popupConfirm">
      <div class="panel-wrap">
        <div class="locate-btn" @click="locateHandler">
          <i class="richic-aim"></i>
        </div>
        <soda-map-view
          v-if="showMap"
          :center="currentGeo"
          :zoom="zoom"
          :language="language"
          @ready="mapReady"
        >
          <soda-mv-poi @change="onChange"></soda-mv-poi>
        </soda-map-view>
      </div>
    </popup>
  </div>
</template>

<script type="text/ecmascript-6">
import Popup from './Popup'
import { getBDLocale, i18n } from '@/common/utils/i18n'
import { isEmpty, throttle } from 'lodash-es'
import { mapGetters } from 'vuex'
import { geoCode } from '@/api'
import { trackEvent } from '@/common/utils/log'

// 不走vue数据响应
let tempGeo = null
export default {
  name: 'FullScreenPoiPicker',
  components: {
    Popup
  },
  inject: ['rootForm'],
  props: {
    value: {
      type: Object,
      required: true
    },
    addrKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: i18n.gettext('校准POI')
    },
    zoom: {
      type: Number,
      default: 13
    }
  },
  data () {
    return {
      // map instance
      map: null,
      showMap: false,
      currentGeo: {},
      language: getBDLocale(),
      loadingToast: null
    }
  },
  computed: {
    ...mapGetters(['geo']),
    showValue () {
      return (this.value.lng && this.value.lat)
        ? this.gettext('已校准')
        : this.gettext('点击校准')
    }
  },
  methods: {
    mapReady (map) {
      this.map = map.map
    },
    locateHandler () {
      this.currentGeo = Object.assign({}, this.geo)
      tempGeo = {
        lng: this.currentGeo.lng,
        lat: this.currentGeo.lat
      }
      this.map.setCenter(this.currentGeo)
      this.map.setZoom(18)
      trackEvent('sailing_gattarman_x_click_user_locate', {
        poi: this.currentGeo
      })
    },
    async show () {
      this.showMap = false
      const addr = (this.rootForm.internalData || {})[this.addrKey]
      let geo = null
      if (isEmpty(this.value)) {
        if (addr) {
          try {
            this.loadingToast = this.$createToast({
              type: 'loading',
              time: 0,
              mask: true
            })
            this.loadingToast.show()
            const res = await geoCode({
              countryId: 52,
              address: addr
            })
            this.loadingToast.hide()
            if (res.errno === 0) {
              const { lng, lat } = res.result[0].base_info
              geo = { lng, lat }
            } else {
              throw new Error('Cannot get geo info')
            }
          } catch (err) {
            console.error(err)
            geo = this.geo
          }
        } else {
          this.$createToast({
            type: 'warn',
            time: 1000,
            txt: i18n.gettext('请先输入门店地址')
          }).show()
          return false
        }
      } else if (this.value.lng && this.value.lat) {
        geo = this.value
      } else {
        geo = this.geo
      }
      this.currentGeo = Object.assign({}, geo)
      tempGeo = {
        lng: this.currentGeo.lng,
        lat: this.currentGeo.lat
      }
      setTimeout(() => {
        this.showMap = true
        this.$refs.popup.show()
      }, 0)
    },
    onChange: throttle(function (event) {
      tempGeo = {
        lat: event.position.lat,
        lng: event.position.lng
      }
    }, 1000),
    popupConfirm () {
      this.$emit('confirm', tempGeo)
      this.showMap = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .popup .popup-panel.full-screen {
  padding-top: var(--barheight);
  height: calc(100vh - 100px);
}
.poi-picker {
  &-btn {
    padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: calc(88px + (var(--barheight)));
    bottom: 0;
    overflow: hidden;
  }
  .locate-btn {
    position: absolute;
    left: 10px;
    bottom: 24px;
    width: 30px;
    height: 30px;
    background: #fff;
    z-index: 99;
    text-align: center;
    i {
      line-height: 30px;
      font-size: 22px;
    }
  }
}
</style>
